module.exports = __webpack_public_path__ + "static/media/sass-logo.811593fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sass-logo.svg
// module id = 86
// module chunks = 0